module.exports = __webpack_public_path__ + "img/badge-most-conversion-keyvue-blue.e3f9ba53.png";